
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("4eVVU", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $fcdbe1c385d435b7$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Danish (Denmark)
var $fcdbe1c385d435b7$export$2e2bcd8739ae039 = {
    'confluence.error.panel.refresh.app': 'Opdater appen',
    'confluence.error.panel.reload.page': "Genindl\xe6s siden",
    'confluence.icon.label': 'Ikon',
    'confluence.modal.dialog.close.modal.button': 'Annuller',
    'confluence.select.required.field.message': "Dette felt er p\xe5kr\xe6vet.",
    'confluence.text.area.required.field.message': "Dette felt er p\xe5kr\xe6vet.",
    'confluence.textfield.validator.email': 'Indtast en gyldig e-mail.',
    'confluence.textfield.validator.number': 'Indtast et gyldigt tal',
    'confluence.textfield.validator.required.field.message': "Dette felt er p\xe5kr\xe6vet.",
    'confluence.textfield.validator.telephone': 'Indtast et gyldigt telefonnummer.',
    'confluence.threeLOPrompt.modal.access.required.title': "Adgang p\xe5kr\xe6vet",
    'confluence.threeLOPrompt.modal.error.title': 'Fejl',
    'confluence.threeLOPrompt.modal.no.authURL.error-message': "Samtykke-URL-adresse blev ikke fundet. Opdater siden, og pr\xf8v igen.",
    'confluence.threeLOPrompt.no.authURL.error-message': "Samtykke-URL-adresse blev ikke fundet. Opdater siden, og pr\xf8v igen.",
    'confluence.threeLOPrompt.use-auth.allow.access.button.text': 'Tillad adgang',
    'confluence.threeLOPrompt.use-auth.configure.access.button.text': 'Konfigurer adgang',
    'confluence.threeLOPrompt.use-auth.default.failed.to.auth.message': 'Godkendelse mislykkedes.',
    'confluence.threeLOPrompt.use-auth.default.prompt.message': "Du skal give appen adgang til Atlassian-produkter p\xe5 dine vegne, f\xf8r {appString} kan vises.",
    'confluence.threeLOPrompt.use-auth.external.auth.prompt.message': "{appString} kr\xe6ver yderligere adgang til din konto.",
    'confluence.threeLOPrompt.use-auth.external.auth.warning.message': 'Advarsel om ekstern godkendelse',
    'confluence.threeLOPrompt.use-auth.this.app.lower.message': 'denne app',
    'confluence.threeLOPrompt.use-auth.this.app.upper.message': 'Denne app',
    'confluence.user.group.unknown.user.message': 'Ukendt bruger',
    'confluence.user.picker.empty.field.error.message': "Dette felt er p\xe5kr\xe6vet.",
    'confluence.user.unknown.user.message': 'Ukendt bruger',
    'forge-ui.form.submit-button.text': 'Send'
};

});


//# sourceMappingURL=da.22a125f8.js.map
